import {Box, Button, createStyles, Dialog, Divider, makeStyles, Theme, Tooltip, withStyles} from "@material-ui/core";
import ChipInput from "material-ui-chip-input";
import CSVReader from "react-csv-reader";
import {CSVLink} from "react-csv";
import CustomSnackBar from "../../../creator/experienceManager/participantsDashboard/component/CustomSnackBar";
import MuiDialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import {useCallback, useEffect, useState} from "react";
import UtilService from "../../../../../helper/service";
import Messages from "../../../../../helper/messages";
import {useDispatch, useSelector} from "react-redux";
import {
  getListParticipants,
  initListDetailData,
  onAddParticipantsToList
} from "../../../../../store/actions/participant/list";
import ParticipantsModal from "./ParticipantsModal";

const useStyles = makeStyles(() => ({
  root: {},
  paper: {
    borderRadius: '24px!important'
  },
  createBtn: {
    width: 91,
    height: 37,
    borderRadius: 6,
    background: '#0179EE',
    color: '#FFFFFF',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#0f9fef'
    },
  },
  cancelBtn: {
    width: 91,
    height: 37,
    borderRadius: 6,
    background: '#F0F0F0',
    color: '#697683',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#e0e0e0',
    },
  },
  textField: {
    "& .MuiOutlinedInput-inputMarginDense": {
      margin: "0!important",
      border: '1px solid #697683',
      padding: 4,
      borderRadius: 3,
      paddingLeft: 6,
      fontSize: 14,
      color: '#717E8B',
    }
  },
  label: {
    "&$focusedLabel": {
      fontSize: 12,
      fontFamily: 'roboto-bold',
      color: "#606B76"
    },
    "&$erroredLabel": {
      color: "#707070"
    }
  },
  focusedLabel: {},
  erroredLabel: {},
  underline: {
    width: '100%',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    "&$error:after": {
      borderBottomColor: "#017AEF"
    },
    "&:after": {
      borderBottom: `3px solid #017AEF`
    }
  },
  error: {},
  description: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683'
  },
  input: {
    marginTop: 50
  },
  addBtn: {
    flex: 1,
    textTransform: "unset",
    backgroundColor: '#F0F0F0',
    color: '#697683',
    marginTop: 16
  },
  addBlueBtn: {
    flex: 1,
    textTransform: "unset",
    backgroundColor: '#017AEF',
    color: '#fff',
    marginTop: 16,
    "&:hover": {
      backgroundColor: '#0f9fef',
    }
  },
  emailChipDiv: {
    marginTop: 30,
    justifyContent: "center",
    display: "flex",
    alignItems: "center"
  },
  csvPanel: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 20
  },
  downloadIcon: {
    height: 27,
    width: 'auto',
    marginTop: 4,
    marginLeft: 15
  },
  csvBtn: {
    width: 100,
    height: 37,
    borderRadius: 4,
    backgroundColor: '#F0F0F0',
    fontSize: '0.875rem',
    fontFamily: 'roboto-regular',
    color: '#697683',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
    '& input': {
      display: 'none'
    },
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#e0e0e0',
    },
  },
  csvLabel: {
    cursor: 'pointer',
    padding: 8
  },
  csvNameLabel: {
    fontSize: 18,
    fontFamily: 'roboto-black',
    color: '#017AEF',
    alignItems: 'center',
    display: 'inline-flex',
    cursor: 'pointer',
    '&:hover': {
      color: '#0f9fef'
    }
  },
  participantsIcon: {
    width: 24,
    height: 24,
    marginTop: 2
  },
  participantsCountDiv: {
    marginTop: 10,
    fontSize: 18,
    fontFamily: 'roboto-black',
    color: '#017AEF',
    alignItems: 'center',
    display: 'inline-flex',
    cursor: 'pointer',
    '&:hover': {
      color: '#0f9fef'
    }
  },
}));

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      paddingTop: 26
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      background: 'transparent!important'
    },
    header: {
      color: '#212D40',
      fontFamily: 'Spartan-bold',
      fontSize: 24,
      paddingLeft: 17,
      paddingBottom: 7,
      display: 'flex',
      alignItems: 'center'
    }
  });

const DialogTitle = withStyles(styles)((props: any) => {
  const {children, classes, onClose, ...other} = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div className={classes.header}>
        {children}
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <img src={'/assets/icons/creatordashboard/project-modal-close.svg'} alt={'img'}/>
          </IconButton>
        ) : null}
      </div>
    </MuiDialogTitle>
  );
});

interface IProps {
  listId: string;
  open: boolean;
  onClose: () => void;
  onClearSelected: () => void;
}

const AddParticipants = (props: IProps) => {
  const classes = useStyles();
  const { open, onClose, listId, onClearSelected } = props;
  const dispatch = useDispatch();
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [emails, setEmails] = useState<string[]>([]);
  const [participants, setParticipants] = useState<string[]>([]);
  const [randomID, setRandomID] = useState(1);
  const [csvName, setCSVName] = useState('');
  const [csvData, setCsvData] = useState<any[]>([]);
  const [participantsModal, setParticipantsModal] = useState(false);
  const [errorEmailIndex, setErrorEmailIndex] = useState(-1);

  const [snackAlertType, handleSnackAlertType] = useState('');
  const [snackAlertMsg, handleSnackMsg] = useState('');
  const [isShownSnackAlert, setShownSnackAlert] = useState(false);

  const parseOptions = {
    header: false,
    skipEmptyLines: true
  };

  const csvHeaders = [
    { label: "Email", key: "email" },
    { label: "Tags", key: "tags" }
  ];

  useEffect(() => {
    if (open) {
      setShownSnackAlert(false);
    }
  }, [open]);

  const init = () => {
    setEmails([]);
    setParticipants([]);
    setRandomID(1);
    setCSVName('');
    setCsvData([]);
    setShownSnackAlert(false);
  };

  const handleClose = () => {
    init();
    onClose();
  };

  const handleBeforeAddEmail = useCallback((email: string) => {
    if (participants.length === 0) {
      if (!UtilService.emailValidate(email)) {
        showErrorAlert('Invalid email');
      }
      return UtilService.emailValidate(email);
    }
    return checkEmailExistence(email);
  }, [participants]);

  const handleAddEmail = (email: string) => {
    setEmails(emails => [...emails, email]);
  };

  const handleDeleteEmail = (_: any, index: number) => {
    setEmails(emails => emails.filter((_: any, _index) => _index !== index));
  };

  const onBlurAddEmail = (event: any) => {
    const value = event.target.value;
    if (value) {
      if (handleBeforeAddEmail(value) && !emails.includes(value)) {
        setEmails(emails => [...emails, value]);
      }
    }
  };

  const onAddEmails = (_emails: any, isCSV: boolean) => {
    const _participants: any = [];
    if (!isCSV && _emails) {
      _emails.forEach((row: any) => {
        _participants.push({email: row, tags: [], is_csv: false})
      });
    }
    setParticipants(isCSV ? _emails : participants.concat(_participants));
    if (!isCSV) {
      setEmails([])
    }
  };

  const showErrorAlert = (message: string) => {
    handleSnackMsg(message);
    handleSnackAlertType('error');
    setShownSnackAlert(true);
  };

  const hideSnackAlert = () => {
    setShownSnackAlert(false);
  };

  const checkEmailExistence = (email: string) => {
    const participantsEmails = participants.map((p: any) => p.email);
    if (participantsEmails.indexOf(email) === -1) {
      if (!UtilService.emailValidate(email)) {
        showErrorAlert('Invalid email');
      }
      return UtilService.emailValidate(email);
    }
    showErrorAlert('Email exist already');
    return false;
  };

  const handleForceCSV = (rows: any, fileInfo: any) => {
    let check = 0;
    const array = ['application/vnd.ms-excel','text/plain','text/csv','text/tsv'];
    if (array.indexOf(fileInfo.type) === -1) {
      handleSnackMsg(Messages.NOTIFICATIONS.ERROR.csvFileValidation);
      handleSnackAlertType("error");
      setShownSnackAlert(true);
      return
    }
    const csvValidEmails: any[] = [...participants];
    rows.forEach((row: any) => {
      const email = row[0] ? row[0].toLowerCase().trim() : '';
      if (UtilService.emailValidate(email) && !csvValidEmails.find((obj) => obj.email === email)) {
        const tagCell = row[1] ? row[1].trim() : '';
        const tags = tagCell.split(',');
        const allTags: any = [];
        tags.map((t: any) => {
          if (t && t != "-" && !allTags.find((tag: any) => tag.tag_name.toLowerCase() === t.toLowerCase().trim())) {
            allTags.push({ tag_name: t.trim() })
          }
        });
        csvValidEmails.push({
          email,
          tags: allTags,
          is_csv: true
        });
        check++;
      }
    });

    if (check === 0) {
      handleSnackMsg(Messages.NOTIFICATIONS.ERROR.csvFileValidation);
      handleSnackAlertType("error");
      setShownSnackAlert(true);
      return
    }
    onAddEmails(csvValidEmails, true);
    setCSVName(fileInfo.name);
    setRandomID(randomID + 1);
  };

  const handleCSVDownload = () => {
    const tempParticipants: any = [
      { email: "user01@getimmersion.com", tags: 'tag1,tag2' },
      { email: "user02@getimmersion.com", tags: 'tag3,tag4' },
      { email: "user03@getimmersion.com", tags: 'tag5' }
    ];
    setCsvData(tempParticipants);
  };

  const onAddParticipants = () => {
    onClearSelected();
    const request = {
      group_id: Number(listId),
      participants: participants
    };
    dispatch(onAddParticipantsToList(apolloClient.client, request, (res: boolean) => {
      if (res) {
        dispatch(initListDetailData());
        setTimeout(() => {
          const req = {
            page: 0,
            group_id: Number(listId)
          };
          dispatch(getListParticipants(apolloClient.client, req, false));
        }, 1000);
      }
    }));
    handleClose();
  };

  const handleParticipantsModal = () => {
    const errorEmailIndex = participants.findIndex((item: any) => !UtilService.emailValidate(item.email));
    if (errorEmailIndex < 0) {
      setParticipantsModal(!participantsModal);
      setErrorEmailIndex(-1);
    } else {
      setErrorEmailIndex(errorEmailIndex)
    }
  };

  const onUpdateParticipants = (newParticipants: string[]) => {
    setParticipants(newParticipants)
  };

  return (
    <Dialog
      disableEscapeKeyDown
      fullWidth={true}
      maxWidth={'sm'}
      open={open}
      classes={{
        root: classes.root,
        paper: classes.paper
      }}
    >
      <div>
        <DialogTitle onClose={handleClose}>
          Add Participants
        </DialogTitle>
        <Divider/>

        <Box m={4} pl={1} pr={1}>
          <div className={classes.emailChipDiv}>
            <ChipInput
              value={emails}
              onBeforeAdd={(email) => handleBeforeAddEmail(email)}
              onAdd={(email) => handleAddEmail(email)}
              onDelete={(email, index) => handleDeleteEmail(email, index)}
              style={{ flex: 14 }}
              id="emails"
              label="Type email address and press space or comma"
              newChipKeyCodes={[13, 32, 188]}
              newChipKeys={[]}
              InputLabelProps={{
                classes: {
                  root: classes.label,
                  focused: classes.focusedLabel,
                  error: classes.erroredLabel
                },
              }}
              InputProps={{
                classes: {
                  root: classes.underline,
                  error: classes.error
                }
              }}
              onBlur={(event) => onBlurAddEmail(event)}
            />
            &nbsp;&nbsp;&nbsp;
            <Button
              variant="contained"
              className={emails && emails.length ? classes.addBlueBtn : classes.addBtn}
              onClick={() => onAddEmails(emails, false)}
            >
              Add
            </Button>
          </div>
          <div className={classes.csvPanel}>
            <div key={randomID}>
              <CSVReader
                cssClass={classes.csvBtn}
                cssLabelClass={classes.csvLabel}
                label="Upload CSV"
                onFileLoaded={handleForceCSV}
                parserOptions={parseOptions}
              />
            </div>
            {csvName && <span className={classes.csvNameLabel} style={{ marginLeft: 30 }}>{csvName}</span>}
            <CSVLink data={csvData} headers={csvHeaders} onClick={handleCSVDownload} filename={`sample_emails.csv`}>
              <Tooltip title="Download CSV Template" placement="bottom">
                <img className={classes.downloadIcon} src={'/assets/icons/download_icon.svg'} alt="CSV Download" />
              </Tooltip>
            </CSVLink>
          </div>
          {participants.length > 0 && (
            <div className={classes.participantsCountDiv} onClick={handleParticipantsModal}>
              <span>{participants.length} Participants added</span>&nbsp;&nbsp;
              <span>
                <img
                  src={'/assets/icons/experiencebuilder/participants_added.svg'}
                  className={classes.participantsIcon} alt="participant"
                />
              </span>
            </div>
          )}
        </Box>
        <Box mt={6} mb={3} mr={4} display='flex' justifyContent='flex-end'>
          <Button onClick={handleClose} className={classes.cancelBtn}>
            Cancel
          </Button>
          &nbsp;&nbsp;&nbsp;
          <Button
            onClick={onAddParticipants}
            className={classes.createBtn}
            disabled={participants.length === 0}
            style={participants.length === 0 ? {backgroundColor: "#F0F0F0"} : {}}
          >
            Save
          </Button>
        </Box>
      </div>

      <ParticipantsModal
        open={participantsModal}
        participants={participants}
        errorEmailIndex={errorEmailIndex}
        onSaveParticipants={onUpdateParticipants}
        onClose={handleParticipantsModal}
      />

      <CustomSnackBar type={snackAlertType} message={snackAlertMsg} open={isShownSnackAlert} onClose={hideSnackAlert} />
    </Dialog>
  )

};

export default AddParticipants;